<template lang="pug">
  v-navigation-drawer(
      bottom
      color="transparent"
      fixed
      height="auto"
      overlay-color="secondary"
      overlay-opacity=".8"
      temporary
      v-bind="$attrs"
      v-on="$listeners"
  )

    v-list(color="#314369" shaped)
      v-list-item(
        v-for="(item, index) in items"
        :key="index"
        @click="handleSelect(item)"
        color="primary"
      )

        v-list-item-content
          v-list-item-title.gray(v-text="item.title")
</template>

<script>
  export default {
    name: 'HomeDrawer',

    props: {
      items: {
        type: Array,
        default: () => ([]),
      },
    },
    methods: {
      handleSelect (item) {
        this.$emit('clicked', item)
      }
    }
  }
</script>
